import {
    RouterModule,
    Routes,
} from "@angular/router";
import { NgModule } from "@angular/core";
import { LayoutComponent } from "./layout.component";
import { PrivateRouteGuard } from "@/core/security/route/guard/private.route.guard";

const routes: Routes = [
    {
        path: "",
        pathMatch: "full",
        redirectTo: "dashboard",
    },
    {
        path: "",
        component: LayoutComponent,
        canActivate: [PrivateRouteGuard],
        children: [
            {
                path: "dashboard",
                loadComponent: () => import("../../pages/private/dashboard/dashboard.component").then((c) => c.DashboardComponent),
                data: {
                    breadcrumb: "Dashboard Analítico",
                },
            },
            {
                path: "cadastros",
                loadChildren: () => import("../../pages/private/cadastros/cadastros.module").then((c) => c.CadastrosModule),
                data: {
                    breadcrumb: "Cadastros",
                },
            },
            {
                path: "compras",
                loadChildren: () => import("../../pages/private/compras/compras.module").then((c) => c.ComprasModule),
                data: {
                    breadcrumb: "Compras",
                },
            },
            {
                path: "configuracoes",
                loadChildren: () => import("../../pages/private/configuracoes/configuracoes.module").then((c) => c.ConfiguracoesModule),
                data: {
                    breadcrumb: "Configurações",
                },
            },
            {
                path: "administracao",
                loadChildren: () => import("../../pages/private/administracao/administracao.module").then((c) => c.AdministracaoModule),
                data: {
                    breadcrumb: "Administração",
                },
            },
        ],
    },
    {
        path: 'not-found',
        loadComponent: () => import("../../pages/private/erros/not-found/not-found.component").then((c) => c.NotFoundComponent),
    },
    { path: '**', redirectTo: '/private/not-found' }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class LayoutRoutingModule { }
